import styled from '@emotion/styled';

export const StyledContent = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;
